import TotalTimeSpentMyVtIwc from './TotalTimeSpentMyVtIwc';

export default TotalTimeSpentMyVtIwc;
